export const pastoral = [{
    name: "ARCHBISHOP OF LAGOS",
    title: "Most Rev. (Dr.) Alfred Adewale Martins",
    imgSrc: require('../assets/Images/Arch-Martins2.jpg'),
    alt: "archbishop"
  },
  {
    name: "PARISH PRIEST",
    title: "Rev. Fr. Joseph Ozoh' Nwokeforo",
    imgSrc: require('../assets/Images/Fr-Ozoh6.jpg'),
    alt: "fr-ozoh"
  }
]